import React from 'react';
import { NavLink } from 'react-router-dom';
import './AdminNav.css';

// Cross-links shared by every admin screen, so each one reaches all the others.
// Admin-only: never put this on creator-facing pages (the UGC guide, per-affiliate dashboards).
const LINKS = [
  { to: '/affiliates', label: '📊 Affiliates' },
  { href: 'https://www.ssemble.com/ugcguide', label: '📘 UGC guide' },
  { to: '/sent-emails', label: '📧 Sent emails' },
  { to: '/affiliates/analytics', label: '📈 Analytics' },
  { to: '/draft-review', label: '🎬 Draft review' },
];

const AdminNav: React.FC = () => (
  <nav className="admin-nav" aria-label="Admin pages">
    {LINKS.map((l) => (l.href
      // External site — opens in a new tab.
      ? <a key={l.href} className="admin-nav__link" href={l.href} target="_blank" rel="noopener noreferrer">{l.label}</a>
      // `end` keeps /affiliates from also lighting up on /affiliates/analytics.
      : <NavLink key={l.to} className="admin-nav__link" to={l.to!} end>{l.label}</NavLink>
    ))}
  </nav>
);

export default AdminNav;
